module.exports = __webpack_public_path__ + "static/media/register-ill1.467ee9f4.svg";